import { render, staticRenderFns } from "./MagicLinkPost.vue?vue&type=template&id=64791b7b&scoped=true&"
import script from "./MagicLinkPost.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPost.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPost.vue?vue&type=style&index=0&id=64791b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64791b7b",
  null
  
)

export default component.exports